import classNames from 'classnames';
import React from 'react';

import { motion } from '../framer-motion-custom';
import * as styles from './Teaser.module.scss';

const Teaser = ({
  as: Comp = motion.small,
  className,
  children,
  ...other
}) => {
  const classname = classNames(
    styles.teaser,
    className
  );

  return (
    <Comp className={classname} {...other}>
      {children}
    </Comp>
  );
};

export default Teaser;
